import { Box, Card, CardContent, Typography } from '@mui/material';

export const ContactUs = () => {
    const contacts = [
        { title: 'President', name: '', email: 'president@monmouthskiclub.com' },
        { title: 'Treasurer', name: '', email: 'treasurer@monmouthskiclub.com'},
        { title: 'Membership', name: '', email: 'membership@monmouthskiclub.com'},
        { title: 'Bookings', name: '', email: 'scherer118@gmail.com'},
        { title: 'Publicity', name: '', email: 'publicity@monmouthskiclub.com'},
        { title: 'Website/IT', name: '', email: 'techsupport@monmouthskiclub.com' },
    ];

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '20px',
            }}
        >
            <Typography variant="h4" color="text.primary" gutterBottom>
                Contact Us
            </Typography>

            <Card sx={{ width: '100%', margin: '20px' }}>
                <CardContent>
                <Typography variant="h6" color="text.primary" gutterBottom>
                    E-mails
                </Typography>
                {contacts.map((contact, index) => (
                    <Typography variant="h6" color="text.secondary" gutterBottom>
                        <a href={`mailto:${contact.email}`}>{contact.title}</a>
                    </Typography>
                ))}
                </CardContent>
            </Card>
        </Box>
    );
};